import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
import { IUploadFileResponse } from "model/File";
const prefix = PREFIX.File;

class FileApiService extends BaseApiService {
  public upload = (files: File[]) => {
    const formData = new FormData();
    files.forEach((e) => formData.append("files", e));
    return this.post<FormData, IUploadFileResponse[]>(
      `${prefix}/upload`,
      formData,
      {
        headers: { "content-type": "multipart/form-data" },
      }
    );
  };
  public deleteFile = (id: string) =>
    this.delete<string>(`${prefix}/delete/${id}`);
}

export default new FileApiService();
